import { createGlobalStyle } from 'styled-components'

import globalStyles from '../../utils/globalStyles'

const GlobalStyles = createGlobalStyle`${globalStyles}`

export default GlobalStyles
